<template>
    <section class="innerpages animate__animated animate__slideInRight">
       <div class="container ">
          <div class="row">
             <div class="col-md-12 listPage">
                <nav aria-label="breadcrumb">
                </nav>
                   <div class="card source-details" v-for="(item, key) in masterData" :key="`lead${key}`">
                     <div  class="lead-detail-link">
                       <div class="card-body">
                          <div class="row">
                             <div class="col-8">
                                <span class="info-title">{{ item.project_name }}</span>
                                <span class="project-title">{{ item.enquiry_source_name }}</span>
                             </div>
                             <div class="col-4 text-right pl-0">
                                <span class="label-Lead">{{ item.month_name }} - {{ item.year }}</span>
                                <span class="label-status">₹ {{ item.average_cpl }}</span>
                             </div>
                          </div>
                       </div>
                     </div>
                   </div>
                   <span style="font-size:12px;">Count: {{masterData.length}}</span>
             </div>
          </div>
       </div>
    </section>
  </template>
  <script>
  export default {
   data(){
     return {
       masterData: [],
       secondLabelProp: "",
       mainLabel: "",
       searchQuery: ''
     }
   },
   created(){
     this.loadTabData();
   },
   watch: {
    $route(to, from) {
      this.loadTabData();
    },
  },
   methods: {
     resetFilter() {
       this.searchQuery = ''
       this.loadTabData()
     },
     loadTabData(){
        let {
          start_date,
          end_date,
          enquiry_source_ids,
          project_ids,
          cpls_wrt_leads,
        } = this.$route.query;
  
        let apiEndpoint = "";
        
        this.mainLabel = "Master Cpl";
        this.secondLabelProp = "assigned_to";
        apiEndpoint = `marketing_activation_report_costs`;
        this.$store.dispatch("setActiveTitle", "Master CPL");
        let params = {
          start_date: start_date,
          end_date: end_date,
          cpls_wrt_leads: cpls_wrt_leads,
          project_ids: project_ids,
          enquiry_source_ids: enquiry_source_ids,
  
        };
        Object.keys(params).forEach((key) => {
          if (!params[key]) delete params[key];
        });
  
        if (JSON.stringify(this.$route.query) !== JSON.stringify(params)) {
          this.$router.replace({ path: this.$route.path, query: params });
        }
        const searchDataUrl = new URLSearchParams(params).toString();
       this.$axios.get(`${apiEndpoint}?${searchDataUrl}`)
         .then(res => this.masterData = res.data.costs)
         .catch(err => swal("Error", err.response.data.message, "error"));
       }
   }
  }
  </script>
  <style scoped>
  .ncd{
   float: none;
   margin-top: 5px;
   margin-bottom: 0;
   display: block;
  }
  .lead-detail-link{
   text-decoration: none;
  }
  
  .btn-clear, .search-icon{
   position: absolute;
   top: 50%;
   right: 4px;
   transform: translateY(-50%);
   background-color: transparent;
   border: none;
   outline: none;
  }
  
  .search-icon{
   right: unset;
   left: 12px;
   width: 15px;
   height: 15px;
   opacity: 0.5;
  }
  
  .btnFilter{
   font-size: 12px;
   padding:12px;
   background-color: #F8E2D0;
   color: rgba(0, 0, 0, 0.5);
   font-weight: 500;
   background: #F2F2F2;
   box-shadow: 2px 3px 16px #F2F2F2;
   border: .25px solid #F2F2F2;
  }
  .card.source-details {
    border: none;
    padding: 14px;
    margin-bottom: 10px;
  }
  </style>